/**
 * 需要想定 (週間) の page 取得 hook。
 *
 * queryKey は caseId だけ (選択日は入れない): 日付の切り替えは取得済みの page の中で
 * 行い、再取得しない (AC-DFW-002)。`placeholderData` を使わないので、別ケースの値が
 * 一瞬描かれることも無い。
 */
import { Code, ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { getDemandForecastWeekly } from '@ebalance/proto/bffuser/v1/demand_forecast_service-DemandForecastService_connectquery'
import type { GetDemandForecastWeeklyResponse } from '@ebalance/proto/bffuser/v1/demand_forecast_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

export function useGetDemandForecastWeekly({
  caseId,
}: {
  caseId: string | undefined
}): UseQueryResult<GetDemandForecastWeeklyResponse, ConnectError> {
  return useQuery(
    getDemandForecastWeekly,
    { caseId: caseId ?? '' },
    {
      enabled: caseId !== undefined && caseId !== '',
      staleTime: 30_000,
      // ケース不正 (InvalidArgument) は単日と同じ画面内の InvalidWorkflowIdView に
      // する。未公開 (FailedPrecondition) を含むそれ以外は既存の server error 表示
      // (global の error boundary) へ。表示中の data がある時の再取得失敗は投げず、
      // 直前の page を残す (単日 useGetDemandForecastDaily と同じ)。
      throwOnError: (error, query) =>
        query.state.data === undefined &&
        (!(error instanceof ConnectError) ||
          error.code !== Code.InvalidArgument),
    },
  )
}
